import(/* webpackMode: "eager", webpackExports: ["ForumBoardClient"] */ "/workspace/.ci/web-hosting-src/platform/forum/ForumBoardClient.tsx");
